import * as React from "react";
import SideBarContainer from "../layouts/sideBar.container";
import { Col, Row } from "react-bootstrap";
import ThreeScene from "./ThreeScene";
import styled from "@emotion/styled";
import Skeleton from "@mui/material/Skeleton";

declare const window: any;

export default function GaleriesContenidoContainer({
  data,
  menuSelected,
  subMenuSelected,
  isSelected,
  theme,
  colors,
  isSideBar,
  isPortrait,
}: any) {
  const divRef = React.useRef(null);
  const [allFiles, setAllFiles] = React.useState([]);
  const [selectedFile, setSelectedFile]: any = React.useState({});
  const [selectedFileIndex, setSelectedFileIndex]: any = React.useState(null);
  const [isFirts, setIsFirts]: any = React.useState(true);
  const [viewportWidth, setViewportWidth] = React.useState(window.innerWidth);
  const [viewportHeight, setViewportHeight] = React.useState(
    window.innerHeight
  );

  React.useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    const timeFirts = setTimeout(() => {
      setIsFirts(false);
    }, 5000);

    // Limpieza del event listener al desmontar el componente
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(timeFirts);
    };
  }, []);

  /* React.useEffect(() => {
    if (divRef.current) {
      const computedStyle = window.getComputedStyle(divRef.current);
    }
  }, [isSideBar, viewportWidth,]); */

  React.useEffect(() => {
    let tempGalleries: any = [];
    if (menuSelected === "Galería" && subMenuSelected === "Galería") {
      data?.forEach((groups) => {
        if (groups?.galleries?.galleries?.length > 0) {
          if (groups?.galleries?.galleries[0]?.length > 0) {
            groups?.galleries?.galleries[0]?.forEach((folders) => {
              if (folders?.links?.length > 0) {
                folders?.links?.forEach((files) => {
                  files.folder = folders?.name;
                  files.type = folders?.type;
                  tempGalleries.push(files);
                });
              }
            });
          }
        }
      });
    } else {
      data?.forEach((folders) => {
        if (folders?.links?.length > 0) {
          folders?.links?.forEach((files) => {
            files.folder = folders?.name;
            files.type = folders?.type;
            tempGalleries.push(files);
          });
        }
      });
    }
    
    setAllFiles(tempGalleries);
    if (selectedFileIndex !== null) {
      setSelectedFile(tempGalleries[selectedFileIndex] !== undefined ? tempGalleries[selectedFileIndex] : tempGalleries[0])
      setSelectedFileIndex(tempGalleries[selectedFileIndex] !== undefined ? selectedFileIndex : 0)
    }
  }, [data]);

  React.useEffect(() => {
    if (
      allFiles.length === 1 &&
      (menuSelected === "Amenidades" || menuSelected === "Inmuebles")
    ) {
      setSelectedFile(allFiles[0]), setSelectedFileIndex(0);
    }
  }, [allFiles]);

  React.useEffect(() => {
    if (selectedFile.length > 0) {
      setIsFirts(false);
    }
  }, [selectedFile]);

  const handleMoveGallerie = (orientation) => {
    if (orientation === "next") {
      setSelectedFileIndex(
        allFiles[selectedFileIndex + 1] !== undefined
          ? selectedFileIndex + 1
          : 0
      );
      setSelectedFile(
        allFiles[selectedFileIndex + 1] !== undefined
          ? allFiles[selectedFileIndex + 1]
          : allFiles[0]
      );
    } else {
      setSelectedFileIndex(
        allFiles[selectedFileIndex - 1] !== undefined
          ? selectedFileIndex - 1
          : allFiles.length - 1
      );
      setSelectedFile(
        allFiles[selectedFileIndex - 1] !== undefined
          ? allFiles[selectedFileIndex - 1]
          : allFiles[allFiles.length - 1]
      );
    }
  };

  const ImagenConFallback = (img) => {
    const handleImageError = (e) => {
      e.target.src = `./UI/gallery/${img.folder.replace(/ /g, "_")}.webp`;
    };

    return (
      <img
        src={`${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/" }${img.link}`}
        onError={handleImageError}
        alt=""
      />
    );
  };

  const getYoutubeVideoId = (url) => {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  };

  const darkenColor = (color, percent) => {
    const f = parseInt(color.slice(1), 16);
    const t = percent < 0 ? 0 : 255;
    const p = percent < 0 ? percent * -1 : percent;
    const R = f >> 16;
    const G = (f >> 8) & 0x00ff;
    const B = f & 0x0000ff;
    return (
      "#" +
      (
        0x1000000 +
        (Math.round((t - R) * p) + R) * 0x10000 +
        (Math.round((t - G) * p) + G) * 0x100 +
        (Math.round((t - B) * p) + B)
      )
        .toString(16)
        .slice(1)
    );
  };

  console.log(selectedFile);
  
/* 
  console.log(allFiles);
  console.log(selectedFile);
  console.log(selectedFileIndex);
  
 */
  return (
    <div
      ref={divRef}
      className={`galeria-container ${theme}`}
      style={
        isSideBar && !isPortrait
          ? {
              paddingLeft:
                !window.functionIsPortrait() && window.functionIsMobileDevice()
                  ? "12.5rem"
                  : "19.25rem",
            }
          : {}
      }
    >
      <div
        className={`galeria-container-row row ${
          Object.keys(selectedFile).length === 0 ? "active" : ""
        }`}
        style={
          isSideBar && !isPortrait
            ? {
                width:
                  !window.functionIsPortrait() &&
                  window.functionIsMobileDevice()
                    ? `calc(${window.innerWidth}px - 10rem )`
                    : `calc(${window.innerWidth}px - 19.25rem )`,
              }
            : { width: "100%", marginLeft: 0 }
        }
      >
        {allFiles?.map((img: any, index: number) => (
          <div
            className={`galeria-container-item col ${
              
              (!isSideBar && window.innerWidth >= 1400)
                ? "col-2"
                : (isSideBar &&
                    window.innerWidth >= 1400) ||
                  (!isSideBar &&
                    window.innerWidth >= 1200 &&
                    window.innerWidth < 1400)
                ? "col-3"
                : (isSideBar &&
                    window.innerWidth >= 1200 &&
                    window.innerWidth < 1400) ||
                  (!isSideBar &&
                    window.innerWidth >= 1000 &&
                    window.innerWidth < 1200)
                ? "col-4"
                : (isSideBar &&
                    window.innerWidth >= 1000 &&
                    window.innerWidth < 1200) ||
                  (!isSideBar &&
                    window.innerWidth >= 800 &&
                    window.innerWidth < 1000)
                ? "col-6"
                : isPortrait
                ? "col-6"
                : !window.functionIsPortrait() &&
                  window.functionIsMobileDevice() &&
                  isSideBar
                ? "col-6"
                : !window.functionIsPortrait() &&
                  window.functionIsMobileDevice() &&
                  !isSideBar
                ? "col-4"
                : "col-12"
            }`}
            onClick={() => {
              setSelectedFile(img), setSelectedFileIndex(index);
            }}
          >
            {img.folder === "Videos" ? (
              <img
                src={`https://img.youtube.com/vi/${getYoutubeVideoId(
                  img.link
                )}/mqdefault.jpg`}
              />
            ) : (
              ImagenConFallback(img)
            )}
            {/* <Skeleton variant="rectangular" width={210} height={118} /> */}
            {<div className="title-galeria-container-item">{img.name}</div>}
            {<div className="subtitle-galeria-container-item">{img.folder}</div>}
          </div>
        ))}
      </div>

      {/* DOWN IS INDIVIDUAL GALERY */}
      <div
        className={`galeria-container-individual ${
          Object.keys(selectedFile).length > 0
            ? "active"
            : Object.keys(selectedFile).length === 0 && !isFirts
            ? "hidden"
            : ""
        }`}
        style={
          isSideBar && !isPortrait
            ? {
                width:
                  !window.functionIsPortrait() &&
                  window.functionIsMobileDevice()
                    ? `calc(${window.innerWidth}px - 10rem )`
                    : `calc(${window.innerWidth}px - 19.25rem )`,
              }
            : { width: "100%" }
        }
      >
        <div
          className="galeria-container-individual-img"
          style={{
            height: `calc(${window.innerHeight}px - ${
              isPortrait ? "20.4375rem" : "10rem"
            } )`,
          }}
        >
          {selectedFile.folder === "Recorridos" ||
          selectedFile.folder === "Videos" ||
          selectedFile.folder === "Brochures" ? (
            <iframe
              src={selectedFile.link}
              title="virtual-tours"
              style={{
                borderRadius: ".5rem",
                border: "none",
              }}
            />
          ) : selectedFile.folder === "Fotos 360°" || selectedFile.folder === "Fotos 360" ? (
            <ThreeScene
              selectedFile={`${
                window.hybrid
                  ? "./"
                  : "https://d1bsymnertnea6.cloudfront.net/"
              }${encodeURIComponent(selectedFile.link)}`}
            />
          ) : selectedFile.folder === "Renders 360°" || selectedFile.folder === "Renders 360" ? (
            <ThreeScene
              selectedFile={`${
                window.hybrid
                  ? "./"
                  : "https://d1bsymnertnea6.cloudfront.net/"
              }${encodeURIComponent(selectedFile.link)}`}
            />
          ) : (
            <img
              src={`${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/" }${selectedFile.link}`}
              alt=""
            />
          )}
        </div>
        <div className="galeria-container-individual-description">
          <div className="galeria-container-individual-description-name">
            <div className="galeria-container-individual-description-name-title">
              {selectedFile?.name?.split(".")[0]}
            </div>{" "}
            <div className="galeria-container-individual-description-name-subTitle">
              {selectedFile.folder}
            </div>
          </div>
          <div className="galeria-container-individual-description-action">
            <div onClick={() => handleMoveGallerie("back")}>
              <i className={`fa fa-chevron-left`}></i>
            </div>{" "}
            <h5>{selectedFileIndex + 1 + "/" + allFiles.length}</h5>
            <div onClick={() => handleMoveGallerie("next")}>
              <i className={`fa fa-chevron-right`}></i>
            </div>
          </div>
          <div className="galeria-container-individual-description-close">
            <div
              style={{ backgroundColor: colors?.main_buttons }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = darkenColor(
                  colors?.main_buttons,
                  -0.2
                );
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = colors?.main_buttons;
              }}
              onClick={() => setSelectedFile({})}
            >
              Cerrar
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
